import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/qingyu'
import HomeView from '../views/HomeView.vue'
import MainLayout from '../layout/MainLayout.vue'

// 路由配置
const routes = [
  // 登录页面 - 不需要布局
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { title: '登录', requiresAuth: false }
  },
  
  // 注册页面 - 不需要布局
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '@/views/register/index.vue'),
    meta: { title: '注册', requiresAuth: false }
  },
  
  // 主布局下的路由
  {
    path: '/',
    component: MainLayout,
    redirect: '/dashboard',
    children: [
      // 仪表盘/首页
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: HomeView,
        meta: { title: '首页', requiresAuth: false }
      },
      
      // 园区管理
      {
        path: 'park',
        name: 'Park',
        redirect: '/park/list',
        meta: { title: '园区管理', requiresAuth: true },
        children: [
          {
            path: 'list',
            name: 'ParkList',
            component: () => import(/* webpackChunkName: "park-list" */ '@/views/park/list/index.vue'),
            meta: { title: '园区列表', requiresAuth: true }
          },
          {
            path: 'detail/:id',
            name: 'ParkDetail',
            component: () => import(/* webpackChunkName: "park-detail" */ '@/views/park/detail/index.vue'),
            meta: { title: '园区详情', requiresAuth: true }
          },
          {
            path: 'application',
            name: 'ParkApplication',
            component: () => import(/* webpackChunkName: "park-application" */ '@/views/park/application/index.vue'),
            meta: { title: '入驻申请', requiresAuth: false }
          },
          {
            path: 'contract',
            name: 'ParkContract',
            component: () => import(/* webpackChunkName: "park-contract" */ '@/views/park/contract/index.vue'),
            meta: { title: '合同管理', requiresAuth: true }
          },
          {
            path: 'payment',
            name: 'ParkPayment',
            component: () => import(/* webpackChunkName: "park-payment" */ '@/views/park/payment/index.vue'),
            meta: { title: '缴费管理', requiresAuth: true }
          },
          {
            path: '3d/:id',
            name: 'Park3D',
            component: () => import(/* webpackChunkName: "park-3d" */ '@/views/park/3d/index.vue'),
            meta: { title: '3D模型交互', requiresAuth: true }
          }
        ]
      },
      
      // 信息提报
      {
        path: 'report',
        name: 'Report',
        redirect: '/report/list',
        meta: { title: '信息提报', requiresAuth: true },
        children: [
          {
            path: 'list',
            name: 'ReportList',
            component: () => import(/* webpackChunkName: "report-list" */ '@/views/report/list/index.vue'),
            meta: { title: '提报列表', requiresAuth: true }
          },
          {
            path: 'create',
            name: 'ReportCreate',
            component: () => import(/* webpackChunkName: "report-create" */ '@/views/report/create/index.vue'),
            meta: { title: '新建提报', requiresAuth: true }
          },
          {
            path: 'detail/:id',
            name: 'ReportDetail',
            component: () => import(/* webpackChunkName: "report-detail" */ '@/views/report/detail/index.vue'),
            meta: { title: '提报详情', requiresAuth: true }
          }
        ]
      },
      
      // 企业服务
      {
        path: 'service',
        name: 'Service',
        redirect: '/service/property',
        meta: { title: '企业服务', requiresAuth: true },
        children: [
          // 物业服务
          {
            path: 'property',
            name: 'PropertyService',
            component: () => import(/* webpackChunkName: "service-property" */ '@/views/service/property/index.vue'),
            meta: { title: '物业服务', requiresAuth: true },
            redirect: '/service/property/repair',
            children: [
              {
                path: 'repair',
                name: 'PropertyRepair',
                component: () => import(/* webpackChunkName: "property-repair" */ '@/views/service/property/repair/index.vue'),
                meta: { title: '物业报修', requiresAuth: true }
              },
              {
                path: 'visitor',
                name: 'VisitorAppointment',
                component: () => import(/* webpackChunkName: "visitor-appointment" */ '@/views/service/property/visitor/index.vue'),
                meta: { title: '访客预约', requiresAuth: true }
              },
              {
                path: 'facility',
                name: 'FacilityReservation',
                component: () => import(/* webpackChunkName: "facility-reservation" */ '@/views/service/property/facility/index.vue'),
                meta: { title: '设施预约', requiresAuth: true }
              }
            ]
          },
          // 通知公告
          {
            path: 'announcement',
            name: 'Announcement',
            component: () => import(/* webpackChunkName: "service-announcement" */ '@/views/service/announcement/index.vue'),
            meta: { title: '通知公告', requiresAuth: true }
          },
          {
            path: 'announcement/detail/:id',
            name: 'AnnouncementDetail',
            component: () => import(/* webpackChunkName: "announcement-detail" */ '@/views/service/announcement/detail/index.vue'),
            meta: { title: '通知详情', requiresAuth: true }
          },
          // 活动列表
          {
            path: 'activity',
            name: 'Activity',
            component: () => import(/* webpackChunkName: "service-activity" */ '@/views/service/activity/index.vue'),
            meta: { title: '活动列表', requiresAuth: true }
          },
          {
            path: 'activity/detail/:id',
            name: 'ActivityDetail',
            component: () => import(/* webpackChunkName: "activity-detail" */ '@/views/service/activity/detail/index.vue'),
            meta: { title: '活动详情', requiresAuth: true }
          },
          // 培训列表
          {
            path: 'training',
            name: 'Training',
            component: () => import(/* webpackChunkName: "service-training" */ '@/views/service/training/index.vue'),
            meta: { title: '培训列表', requiresAuth: true }
          },
          {
            path: 'training/detail/:id',
            name: 'TrainingDetail',
            component: () => import(/* webpackChunkName: "training-detail" */ '@/views/service/training/detail/index.vue'),
            meta: { title: '培训详情', requiresAuth: true }
          },
          // 其他服务（规划中）
          {
            path: 'tech',
            name: 'TechService',
            component: () => import(/* webpackChunkName: "service-tech" */ '@/views/service/tech/index.vue'),
            meta: { title: '科技服务', requiresAuth: true }
          },
          {
            path: 'finance',
            name: 'FinanceService',
            component: () => import(/* webpackChunkName: "service-finance" */ '@/views/service/finance/index.vue'),
            meta: { title: '金融服务', requiresAuth: true }
          },
          {
            path: 'production',
            name: 'ProductionService',
            component: () => import(/* webpackChunkName: "service-production" */ '@/views/service/production/index.vue'),
            meta: { title: '生产服务', requiresAuth: true }
          },
          // 信息提报
          {
            path: 'tibao',
            children: [
              {
                path: 'list',
                name: 'TibaoList',
                component: () => import('@/views/service/tibao/list/index.vue'),
                meta: {
                  title: '信息提报',
                  requiresAuth: true
                }
              },
              {
                path: 'detail/:id',
                name: 'TibaoDetail',
                component: () => import('@/views/service/tibao/detail/index.vue'),
                meta: {
                  title: '填写信息提报',
                  requiresAuth: true
                }
              }
            ]
          },
          // 专利服务
          {
            path: 'zhuanli',
            children: [
              {
                path: 'list',
                name: 'ZhuanliList',
                component: () => import('@/views/service/zhuanli/list/index.vue'),
                meta: {
                  title: '专利列表',
                  requiresAuth: true
                }
              },
              {
                path: 'detail/:id',
                name: 'ZhuanliDetail',
                component: () => import('@/views/service/zhuanli/detail/index.vue'),
                meta: {
                  title: '专利详情',
                  requiresAuth: true
                }
              }
            ]
          },
          // 软著服务
          {
            path: 'ruanzhu',
            children: [
              {
                path: 'list',
                name: 'RuanzhuList',
                component: () => import('@/views/service/ruanzhu/list/index.vue'),
                meta: {
                  title: '软著列表',
                  requiresAuth: true
                }
              },
              {
                path: 'detail/:id',
                name: 'RuanzhuDetail',
                component: () => import('@/views/service/ruanzhu/detail/index.vue'),
                meta: {
                  title: '软著详情',
                  requiresAuth: true
                }
              }
            ]
          }
        ]
      },
      
      // 用户中心
      {
        path: 'user',
        name: 'User',
        redirect: '/user/profile',
        meta: { title: '用户中心', requiresAuth: true },
        children: [
          {
            path: 'profile',
            name: 'UserProfile',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/user/profile/index.vue'),
            meta: { title: '个人信息', requiresAuth: true }
          },
          {
            path: 'security',
            name: 'UserSecurity',
            component: () => import(/* webpackChunkName: "user-security" */ '@/views/user/security/index.vue'),
            meta: { title: '账号安全', requiresAuth: true }
          },
          {
            path: 'company',
            name: 'UserCompany',
            component: () => import(/* webpackChunkName: "user-company" */ '@/views/user/company/index.vue'),
            meta: { title: '企业信息', requiresAuth: true }
          },
          {
            path: 'company/yuebao/create',
            name: 'CompanyYuebaoCreate',
            component: () => import('@/views/user/company/yuebao/create/index.vue'),
            meta: { title: '提交经营信息', requiresAuth: true }
          },
          {
            path: 'bind',
            name: 'EmployeeBind',
            component: () => import(/* webpackChunkName: "employee-bind" */ '@/views/user/bind/index.vue'),
            meta: { title: '员工绑定', requiresAuth: true }
          }
        ]
      }
    ]
  },
  
  // 测试页面（开发阶段保留）
  {
    path: '/element-test',
    name: 'elementTest',
    component: () => import(/* webpackChunkName: "element-test" */ '../components/ElementTest.vue')
  },
  
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "not-found" */ '@/views/error/404.vue')
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 智慧园区平台` : '智慧园区平台'
  
  // 检查是否需要登录权限
  if (to.meta.requiresAuth) {
    const userStore = useUserStore()
    if (!userStore.isLoggedIn && !userStore.checkTokenValidity()) {
      // 未登录，重定向到登录页
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
